module.exports = __webpack_public_path__ + "static/img/Bachelor_010699.558ff0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010699.jpg
// module id = 225
// module chunks = 0